// @flow
import * as React from 'react';

import type { PropsBulletList } from './types';

import {
  StyledPoinerList,
  StyledHeadlineText,
  StyledList,
  StyledListItem,
  StyledParagraph
} from './styles';

const BulletList = ({ title, bullets, variant }: PropsBulletList) => (
  <StyledPoinerList>
    {title && <StyledHeadlineText>{title}</StyledHeadlineText>}
    {bullets.length > 1 ? (
      <StyledList variant={variant}>
        {bullets.map(bullet => (
          <StyledListItem variant={variant} key={bullet}>
            {bullet}
          </StyledListItem>
        ))}
      </StyledList>
    ) : (
      <StyledParagraph>{bullets[0]}</StyledParagraph>
    )}
  </StyledPoinerList>
);

export default BulletList;
